import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Map } from "lucide-react";
import { useReviewMode } from "../context/ReviewModeContext";
import TransitMap from "./TransitMap";

export default function Miscellaneous() {
  const [viewMode, setViewMode] = useState("menu");
  const [hoveredCard, setHoveredCard] = useState(null);
  const { setReviewMode } = useReviewMode();
  const location = useLocation();

  useEffect(() => {
    setViewMode("menu");
  }, [location.pathname, location.search, location.key]);

  return (
    <div style={s.page} id="ado-miscellaneous-container">
      {viewMode === "menu" ? (
        <div style={{ padding: "clamp(12px, 4vw, 24px)", boxSizing: "border-box", width: "100%" }}>
          <div style={s.header}>
            <div style={s.breadcrumb}>Administration &gt; Miscellaneous</div>
            <h1 style={s.title}>Miscellaneous</h1>
            <p style={s.sub}>Additional administration utilities and workflow references.</p>
          </div>

          <div style={s.grid}>
            <div
              style={{
                ...s.menuCard,
                borderLeft: hoveredCard === "transit" ? "6px solid #1d4ed8" : "6px solid transparent",
                borderColor: hoveredCard === "transit" ? "#1d4ed8" : "#e2e8f0",
                transform: hoveredCard === "transit" ? "translateY(-4px)" : "none",
                boxShadow: hoveredCard === "transit" ? "0 12px 28px rgba(15,23,42,0.12)" : "none",
              }}
              role="button"
              tabIndex={0}
              onClick={() => {
                setReviewMode(true);
                setViewMode("transit-map");
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  setReviewMode(true);
                  setViewMode("transit-map");
                }
              }}
              onMouseEnter={() => setHoveredCard("transit")}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div style={s.cardTop}>
                <div
                  style={{
                    ...s.iconBox,
                    background: hoveredCard === "transit" ? "rgba(29, 78, 216, 0.08)" : "#f1f5f9",
                  }}
                >
                  <Map size={20} color={hoveredCard === "transit" ? "#1d4ed8" : "#64748b"} />
                </div>
              </div>
              <div>
                <h3 style={s.cardTitle}>Workflow Overview</h3>
                <p style={s.cardDesc}>
                  Follow work item REQ-069684 across a workflow line and six connected stations.
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <TransitMap
          onBack={() => {
            setReviewMode(false);
            setViewMode("menu");
          }}
        />
      )}
    </div>
  );
}

const s = {
  page: {
    minHeight: "100vh",
    boxSizing: "border-box",
    maxWidth: "100%",
  },
  header: { marginBottom: "20px" },
  breadcrumb: {
    fontSize: "12px",
    color: "#94a3b8",
    marginBottom: "6px",
  },
  title: {
    margin: 0,
    fontSize: "26px",
    fontWeight: "700",
    color: "#0f172a",
  },
  sub: {
    color: "#64748b",
    marginTop: "5px",
    fontSize: "14px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 320px))",
    gap: "clamp(12px, 3vw, 18px)",
    width: "100%",
    boxSizing: "border-box",
    marginTop: "10px",
  },
  menuCard: {
    background: "#fff",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    padding: "clamp(14px, 3vw, 18px)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    width: "100%",
    maxWidth: "320px",
    boxSizing: "border-box",
    textAlign: "left",
  },
  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "12px",
    flexWrap: "wrap",
  },
  iconBox: {
    padding: "10px",
    borderRadius: "10px",
    flexShrink: 0,
    display: "inline-flex",
  },
  cardTitle: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#0f172a",
  },
  cardDesc: {
    marginTop: "5px",
    fontSize: "13px",
    color: "#64748b",
    lineHeight: "1.4",
  },
};
